import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import useShopHeaderImage from '@hooks/images/useShopHeaderImage';
import { isClosed } from '@utils/shop';
import DeliveryPartnerInfo from '@shopDetails/components/DeliveryPartnerInfo';
import ShopHeaderActions from '@shopDetails/components/ShopHeaderActions';
import MaxProductQuantity from '@shopDetails/components/MaxProductQuantity';
import { TAG_TYPE } from '@components/Tag';
import {
  Container,
  ContainerRelative,
  BackgroundImage,
  HeaderContainer,
  Title,
  DeliveryInfo,
  NotificationsContainer,
  Tag,
  Wrapper,
  SearchInput,
  WrapperHeader,
  Gradient,
  MenuSearchInputContainer,
} from './components';

const HEIGHT_BACKGROUND = '100px';

function MainHeaderGroceries({
  shop,
  show,
  subHeader,
  children,
  onSearchClick,
  searchPlaceholder,
}) {
  const showProductQuantity = useMemo(() => shop?.maxProductQuantity, [shop]);
  const backgroundImage = useShopHeaderImage(shop);

  return (
    <Container show={show}>
      <BackgroundImage
        src={backgroundImage}
        isClosed={isClosed(shop)}
        height={HEIGHT_BACKGROUND}
      />
      <Gradient />
      <MenuSearchInputContainer>
        <SearchInput
          onClick={onSearchClick}
          placeholder={searchPlaceholder}
          disabled
          background="primary"
        />
      </MenuSearchInputContainer>
      <ContainerRelative>
        <HeaderContainer>
          <Wrapper>
            {Boolean(shop?.name) && (
              <WrapperHeader>
                <Title>{shop.name}</Title>
                <ShopHeaderActions backgroudIcon size="small" />
              </WrapperHeader>
            )}
            <DeliveryInfo showMaxProductQuantity={false} />
            <NotificationsContainer>
              <DeliveryPartnerInfo tagType={TAG_TYPE.DEFAULT} />
              {Boolean(showProductQuantity) && (
                <Tag text={<MaxProductQuantity />} rounded />
              )}
            </NotificationsContainer>
          </Wrapper>
        </HeaderContainer>
        {subHeader}
        {children}
      </ContainerRelative>
    </Container>
  );
}

MainHeaderGroceries.propTypes = {
  show: PropTypes.bool,
  shop: PropTypes.object.isRequired,
  subHeader: PropTypes.node,
  children: PropTypes.node,
  onSearchClick: PropTypes.func,
  searchPlaceholder: PropTypes.string,
};

MainHeaderGroceries.defaultProps = {
  show: true,
};

export default MainHeaderGroceries;
